export const cancelFullScreen = () => {
  if (document.exitFullscreen) {
    document
      .exitFullscreen()
      .then(() => {})
      .catch(() => {});
  } else if (document.mozCancelFullScreen) {
    /* Firefox */
    document
      .mozCancelFullScreen()
      .then(() => {})
      .catch(() => {});
  } else if (document.webkitExitFullscreen) {
    /* Chrome, Safari and Opera */
    document
      .webkitExitFullscreen()
      .then(() => {})
      .catch(() => {});
  } else if (document.msExitFullscreen) {
    /* IE/Edge */
    document
      .msExitFullscreen()
      .then(() => {})
      .catch(() => {});
  }
};

export const getFullScreen = () => {
  try {
    if (document.body.requestFullscreen) {
      document.body.requestFullscreen();
    } else if (document.body.mozRequestFullScreen) {
      /* Firefox */
      document.body.mozRequestFullScreen();
    } else if (document.body.webkitRequestFullscreen) {
      /* Chrome, Safari & Opera */
      document.body.webkitRequestFullscreen();
    } else if (document.body.msRequestFullscreen) {
      /* IE/Edge */
      document.body.msRequestFullscreen();
    }
  } catch {
    console.log("their is some full screen error");
  }
};
